import React, { useEffect, useState } from "react";
import api from "../../../utils/api";
import "./Users.css";

const TABS = ["pending", "active", "blocked"];
const PAGE_SIZE = 6;

const Users = () => {
  const [allUsers, setAllUsers] = useState([]);
  const [tab, setTab] = useState("pending");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

//Fetch all users
const fetchUsers = async () => {
  try {
    const res = await api.get("/admin/users");
    setAllUsers(res.data);
  } catch {
    console.error("Failed to fetch users");
  } finally {
    setLoading(false);
  }
};

  const updateStatus = async (id, status) => {
    try {
      await api.put(`/admin/update-user-status/${id}`, { status });
      setAllUsers(prev =>
        prev.map(u =>
          u._id === id ? { ...u, status } : u
        )
      );
    } catch {
      alert("Action failed");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const filtered = allUsers
    .filter(u => u.status === tab)
    .filter(
      u =>
        u.name.toLowerCase().includes(search.toLowerCase()) ||
        u.email.toLowerCase().includes(search.toLowerCase())
    );

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const paginated = filtered.slice(
    (page - 1) * PAGE_SIZE,
    page * PAGE_SIZE
  );

  useEffect(() => setPage(1), [tab, search]);

  if (loading) return <p>Loading users...</p>;

  return (
    <div className="users-container">
      <h2>👥 User Management</h2>

      {/* Tabs */}
      <div className="tabs">
        {TABS.map(t => (
          <button
            key={t}
            className={tab === t ? "active" : ""}
            onClick={() => setTab(t)}
          >
            {t.toUpperCase()}
          </button>
        ))}
      </div>

      {/* Search */}
      <input
        className="search"
        placeholder="Search users..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />

      {/* Users */}
      {paginated.length === 0 ? (
        <p className="empty">No users found</p>
      ) : (
        <div className="user-grid">
          {paginated.map(user => (
            <div className="user-card" key={user._id}>
              <h3>{user.name}</h3>
              <p>{user.email}</p>
              <span className="role">{user.role}</span>
              <span className={`badge ${user.status}`}>
                {user.status}
              </span>

              {tab === "pending" && (
                <div className="actions">
                  <button
                    className="approve"
                    onClick={() =>
                      updateStatus(user._id, "active")
                    }
                  >
                    Approve
                  </button>
                  <button
                    className="reject"
                    onClick={() =>
                      updateStatus(user._id, "blocked")
                    }
                  >
                    Reject/ Block
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination">
          <button
            disabled={page === 1}
            onClick={() => setPage(p => p - 1)}
          >
            Prev
          </button>
          <span>
            Page {page} of {totalPages}
          </span>
          <button
            disabled={page === totalPages}
            onClick={() => setPage(p => p + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Users;
